
import { defineComponent } from 'vue';
import factory from '../Singles/Factory.vue';
import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { HistoryPosition } from '@/models/Blocks/history-position';
import { BlockEvents } from '@/models/Blocks/block-events';
import { TemplateStruct, TemplateStructRow, TemplateStructCol } from "@/models/Blocks/Itens/Types/template-struct";
import { DeviceType } from "@/models/Blocks/Itens/Types/device-type";
import { Guid } from "@/models/identify"; 

export default defineComponent({
    name: 'block',
    components: {
        factory,
        block: () => import('./Component.vue')
    },
    props: {
        title: {
            type: String,
            default: null
        },
        titleAlign: {
            type: String,
            default: null
        },
        struct: {
            type: TemplateStruct,
            default: () => new TemplateStruct()
        },
        className: {
            type: [Object, String],
            default: () => { }
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        cols:{
            type: Number,
            default: undefined
        },
        isVisible:{
            type: Boolean,
            default: true
        },
        isChild:{
            type: Boolean,
            default: false
        },
        context: {
            type: String,
            default: ''
        }
    },
    data(){
        return {
            positionLoading: false
        };
    },
    mounted() {
        this.componentMounted();
        this.positionScroll();
    },
    watch:{
        struct(){
            this.positionScroll();
        }
    },
    computed:{
        elemClass(): {[key: string]: any}{
            let base: {[key: string]: any} = typeof this.className == 'string' ? {[this.className]: true} : this.className;
            return {
                'prz-blk-dkt': this.device == DeviceType.desktop,
                'prz-blk-mob': this.device == DeviceType.mobile,
                'prz-mob-grd': this.device == DeviceType.mobile,
                'prz-grd-12': this.device == DeviceType.desktop && this.struct.cols == 12,
                'prz-grd-16': this.device == DeviceType.desktop && this.struct.cols == 16,
                'prz-blk-child': this.isChild,
                'prz-blk-no-title': !this.title && !this.isChild && this.context == 'HOMEPAGE',
                ...base
            }
        },
        numCols():number{
            if(this.struct.cols){
                return this.struct.cols;
            }
            return this.device == DeviceType.mobile ? 6 : 12;
        },
        device():DeviceType{
            return DeviceType.desktop;
        }
    },
    methods: {
        componentMounted(){
            BlockEvents.AddEventsListener(this);
        },
        positionScroll(){
            if (this.struct.key) {
                let hp = HistoryPosition.getInstance(this.struct.key);
                if (hp.load()) {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            hp.scrollTo();
                        }, (this.device == DeviceType.desktop ? 100 : 50));
                    });
                }
            }
        },
        classGrid(row: TemplateStructRow, col: TemplateStructCol) {
            if(this.device == DeviceType.mobile){
                return { 'prz-mob-grd-half': row.cols.length > 1, 'prz-mob-grd-full': row.cols.length == 1 };
            }
            if(this.device == DeviceType.desktop){
                let cols = this.cols ?? this.struct.cols;
                let dflt = cols / row.cols.length;
                let c = (((col.width ?? dflt) / cols) * this.struct.cols);
                if(Math.round(c) == c){
                    return {[`prz-grd-col-${c}`]: true};
                }else{
                    return null;
                }
            }
        },
        styleGrid(row: TemplateStructRow, col: TemplateStructCol): any|null {
            if(this.device == DeviceType.mobile){
                return null;
            }
            let clss = this.classGrid(row,col);
            if(clss){
                return null;
            }
            let cols = this.cols ?? this.struct.cols;
            let w = ((col.width ?? 12) / cols);
            return {
                '-webkit-box-flex:': '0',
                '-webkit-box-sizing:': 'border-box',
                'box-sizing:': 'border-box',
                'flex': `0 0 ${w*100}%`,
                'max-width': `0 0 ${w*100}%`
            }
        },
        getBlockItem(value: BlockItem | TemplateStruct): BlockItem | undefined {
            let item = value instanceof BlockItem ? value : undefined;
            if(item && !item.deviceType) {
                item.deviceType = this.device;
            }
            return item;
        },
        getTemplateStruct(value: BlockItem | TemplateStruct): TemplateStruct | undefined {
            return value instanceof TemplateStruct ? value : undefined;
        },
        getKey(value: BlockItem | TemplateStruct): string {
            let guid = Guid.generation();
            if(value instanceof TemplateStruct){
                return value.key??guid;
            }
            if(value instanceof BlockItem){
                return value.positionKey??guid;
            }
            return guid;
        }
    }
});
